<template>
  <div class="cus-modal chooseTask">
    <div class="selected-task">
      <div style="width: 90px;"><p>{{t('已选择的任务')}}：</p></div>
      <div class="tasks">
        <div class="items">
          <Tag
            v-for="item in lists"
            :key="item.ID"
            closable
            @on-close="handleClose(item)"
          >{{ item.MONITOR_NAME }}</Tag>
        </div>
        <p class="tip">{{t('最多只能选择{}个任务', componentData.max || 10)}}</p>
      </div>
    </div>
    <OmsTable
      :jordan-table-config="tableConfig"
      @on-select="onSelect"
      @on-select-cancel="onSelectCancel"
      @on-page-change="pageChange"
      @on-page-size-change="pageSizeChange"
      @on-select-all="onSelectAll"
      @on-select-all-cancel="onSelectAllCancel"
    />
  </div>
</template>

<script>
export default {
  name: 'chooseTask',
  props: {
    componentData: {}
  },
  data() {
    return {
      lists: [], // 记录最新的已选择的任务
      tableConfig: {
        indexColumn: true,
        isShowSelection: true,
        pageShow: true, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        border: true, // 是否显示纵向边框
        height: 280,
        total: 0, // 设置总条数
        pageSizeOpts: [20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 20, // 每页条数
        current: "", // 当前页
        data: [],
        selection: [],
        columns: [
          {
            key: 'AP_B_DATAMONITOR_BILL_BILL_TYPE',
            title: t('信息类型') ,
          },
          {
            key: 'AP_B_DATAMONITOR_BILL_TYPE',
            title: t('类型划分')
          },
          {
            key: 'CATEGORY',
            title: t('任务分类'),
          },
          {
            key: 'MONITOR_NAME',
            title: t('任务名称')
          },
          {
            key: 'REMARK',
            title: t('任务说明')
          },
        ],
        businessFormConfig: {
          formData: [
            {
              style: 'select',
              label: t('信息类型'),
              value: 'AP_B_DATAMONITOR_BILL_BILL_TYPE',
              width: '12',
              options: [],
              multiple: true
            },
            {
              style: 'input',
              label: t('任务名称'),
              value: 'AP_B_DATAMONITOR_CONFIG_NAME',
              width: '12',
              inputenter: () => {
              }
            },
            {
              style: 'select',
              label: t('类型划分'),
              value: 'AP_B_DATAMONITOR_BILL_TYPE',
              width: '12',
              options: [
                { label: t('主数据'), value: 1 },
                { label: t('业务单据'), value: 2 }
              ],
              multiple: true
            },
            {
              style: 'input',
              label: t('任务说明'),
              value: 'REMARK',
              width: '12',
              inputenter: () => {
              }
            },
          ],
          formValue: {
            AP_B_DATAMONITOR_BILL_BILL_TYPE: '',
            AP_B_DATAMONITOR_CONFIG_NAME: '',
            AP_B_DATAMONITOR_BILL_TYPE: '',
            REMARK: '',
          }
        },
        businessButtonConfig: {
          typeAll: 'default', // 按钮统一风格样式
          btnsite: 'left', // 按钮位置 (right , center , left)
          buttons: [
            {
              text: t('查询'), //查询
              type: 'primary',
              btnclick: () => {
                this.query()
              }
            },
            {
              text: t('重置'), // 重置
              btnclick: () => {
                this.reset()
              }
            },
            {
              text: t('确定'), // 确认
              btnclick: () => {
                this.confirm()
              }
            }
          ]
        }
      },
    }
  },
  watch: {
    componentData: {
      handler(v) {
        if (v.system) {
          let tasks = Array.isArray(v.system) ? v.system : v.system.DATAMONITOR_SYSTEM_CONFIG_LIST
          this.lists = tasks.map(i => i.MONITOR_DATA_LIST).flat()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    oldTasks() {
      // 已选择的任务
      const { system } = this.componentData
      if (system) {
        let tasks = Array.isArray(system) ? system : system.DATAMONITOR_SYSTEM_CONFIG_LIST
        return tasks.map(i => i.MONITOR_DATA_LIST).flat()
      }
      return []
    },
  },
  mounted() {
    this.getTableQuery()
    this.query()
  },
  methods: {
    // 获取信息类型选项
    async getTableQuery() {
      const params = new FormData();
      params.append('table', 'AP_B_DATAMONITOR_BILL')
      params.append('getcmd', 'y')
      const { data: { code, datas, message }} = await this.service.common.getTableQuery(params)
      if (code == 0) {
        const billType = datas.dataarry.find(i => i.colname == 'BILL_TYPE')
        if (billType && billType.combobox) {
          this.tableConfig.businessFormConfig.formData[0].options = billType.combobox.map(i => {
            return {
              label: i.limitdesc,
              value: i.limitval
            }
          })
        }
      }
    },
    // 查询系统任务
    async query() {
      const { system, billType } = this.componentData
      let AP_B_DATAMONITOR_SYSTEM_ID = ['1'] // 默认中台系统 1
      if (system) {
        // 对外系统
        AP_B_DATAMONITOR_SYSTEM_ID = system.DATAMONITOR_SYSTEM_ID
      }
      // 如果是中台系统，则信息类型默认为当前tab, 且字段不可编辑；对外系统可编辑
      this.tableConfig.businessFormConfig.formValue.AP_B_DATAMONITOR_BILL_BILL_TYPE = billType
      this.tableConfig.businessFormConfig.formData[0].disabled = !!billType
    
      const params = new FormData();
      const searchdata = {
        table: 'AP_B_DATAMONITOR_CONFIG',
        startindex: (this.tableConfig.current - 1) * this.tableConfig.pageSize, // 起始下标
        range: this.tableConfig.pageSize,
        fixedcolumns: {
          ISACTIVE: ["=Y"],
          AP_B_DATAMONITOR_SYSTEM_ID
        },
        column_include_uicontroller: true,
        isolr: false
      }
      for (let key in this.tableConfig.businessFormConfig.formValue) {
        const v = this.tableConfig.businessFormConfig.formValue[key]
        if (v != '') {
          if (Array.isArray(v)) {
            searchdata.fixedcolumns[key] = v.map(i => `=${i}`)
          } else {
            searchdata.fixedcolumns[key] = v
          }
        }
      }
      params.append('searchdata', JSON.stringify(searchdata));
      const { data: { code, datas, message }} = await this.service.common.QueryList(params)
      if (code == 0) {
        const rowData = []
        datas.row.forEach((obj) => {
          const newObj = {}
          for (let key in obj) {
            newObj[key] = obj[key].val
          }
          rowData.push(newObj)
        })
        this.tableConfig.data = rowData
        this.tableConfig.total = datas.totalRowCount
      } else {
        this.tableConfig.data = []
        this.tableConfig.total = 0
        this.$Message.error(message)
      }
    },
    // 确认
    confirm() {
      let max = this.componentData.max || 10
      const { system, billType } = this.componentData
      const systemId = system && system.DATAMONITOR_SYSTEM_ID || '1'
      if (!this.tableConfig.selection.length && this.lists.length == this.oldTasks.length) {
        this.$parent.$parent.closeConfirm();
        return 
      }
      if (this.oldTasks.length + this.tableConfig.selection.length > max) {
        return $fcWarn({ content: t('最多只能选择{}个任务', max) })
      }
      const selected = [...this.tableConfig.selection, ...this.lists].map(i => Number(i.ID))
      const configIds = [...new Set(selected)] // 去重
      const serachParams = new URLSearchParams();
      serachParams.append('systemId', systemId);
      serachParams.append('configIds', configIds);
      if (systemId == '1') {
        serachParams.append('billType', billType);
      }
      this.service.systemConfig.saveMonitorPageConfig(serachParams).then(res => {
        if (res.data.code == 0) {
          this.$parent.$parent.$parent.system(systemId == '1')
          this.$Message.success(res.data.message)
        }
      })
      this.$parent.$parent.closeConfirm();
    },
    handleClose(item) {
      this.lists = this.lists.filter(i => i.ID != item.ID)
    },
    // 重置表单
    reset() {
      this.tableConfig.businessFormConfig.formValue = {
        AP_B_DATAMONITOR_BILL_BILL_TYPE: '',
        AP_B_DATAMONITOR_CONFIG_NAME: '',
        AP_B_DATAMONITOR_BILL_TYPE: '',
        REMARK: '',
      }
    },
    // 分页change 事件
    pageChange(val) {
      this.tableConfig.current = val;
      this.query();
    },
    // 切换分页条数 
    pageSizeChange(val) {
      this.tableConfig.pageSize = val;
      this.query();
    },
    // 选中某一项时触发
    onSelect(selection) {
      this.tableConfig.selection = selection;
    },
    // 取消选中某一项时触发
    onSelectCancel(selection) {
      this.tableConfig.selection = selection;
    },
    // 点击全选时触发
    onSelectAll(selection) {
      this.tableConfig.selection = selection;
    },
    // 点击取消全选时触发
    onSelectAllCancel(selection) {
      this.tableConfig.selection = selection;
    }
  }
}
</script>

<style lang="less" scoped>
.selected-task {
  display: flex;
  line-height: 30px;
  margin-bottom: 10px;
  .tip {
    color: red;
  }
  .tasks {
    flex: 1 1 0;
    .items {
      max-height: 80px;
      overflow: auto;
    }
  }
}
/deep/ .fromBtn.FormPadding {
  padding-bottom: 30px;
}
/deep/ .cus-modal .businessButton {
  left: 0;
}
</style>